const radioStyle: React.CSSProperties = {
  width: 14,
  height: 14,
  borderRadius: '50%',
  border: '2px solid #4b5563',
  flexShrink: 0,
};
const radioActiveStyle: React.CSSProperties = {
  ...radioStyle,
  border: '2px solid #22d3ee',
  background: 'radial-gradient(circle, #22d3ee 40%, transparent 45%)',
};

export default function ConfigAllocationMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Allocation <span style={{ fontWeight: 400, color: '#4b5563', textTransform: 'none', letterSpacing: 0, fontSize: '0.5625rem' }}>(optional)</span></div>
      <div className="platform-mock-body">
        <div className="mock-sidebar-section">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0.25rem 0' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'default' }}>
              <span style={radioActiveStyle} />
              <span style={{ fontSize: '0.6875rem', color: '#e5e7eb' }}>Reinvest profits <span style={{ color: '#6b7280' }}>(compounding)</span></span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'default' }}>
              <span style={radioStyle} />
              <span style={{ fontSize: '0.6875rem', color: '#9ca3af' }}>Fixed capital <span style={{ color: '#6b7280' }}>(no compounding)</span></span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'default' }}>
              <span style={radioStyle} />
              <span style={{ fontSize: '0.6875rem', color: '#9ca3af' }}>Capped <span style={{ color: '#6b7280' }}>(compounding with limit)</span></span>
            </label>
          </div>
          <div style={{ fontSize: '0.5625rem', color: '#4b5563', fontStyle: 'italic', marginTop: '0.25rem' }}>
            Profits are reinvested, increasing position sizes over time.
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">Control how profits are handled between trades: compound, fixed, or capped.</div>
    </div>
  );
}
